/**
 * @file テンプレート
 */

'use strict';
import Common from '../Utils/Common';

let instance = null;

/**
 * @class Template
 * @classdesc テンプレート
 */
export default class Template {

	/**
	 * @constructor
	 */
	constructor() {
		if (instance) {
			return instance;
		}

		instance = this;
		return instance;
	};


	/**
	 * @memberof Template
	 * @param {json} categories - カテゴリーデータ
	 * @param {number} level - カテゴリー階層レベル
	 * @return {string} select - カテゴリー選択セレクトボックス
	 */
	static CreateCategories(categories, level) {
		console.log(`Template.CreateCategories/ level: ${level}`);
		let select;
		if(level == 1){
			select =
`<div class="input-select">
	<select name="cat2" class="input-select__select get-child-category cat2">
		<option value="">選択してください</option>`;
		}else if(level == 2){
			select =
`<div class="input-select">
	<select name="cat3" class="input-select__select">
		<option value="">選択してください</option>`;
		}
		for(let i = 0; i < categories.length; i++){
			select += `<option value="${categories[i].category_id}">${categories[i].name}</option>`
		}
		select += `</select></div>`;
		console.log(select);
		return select;
	};
}